// PWA: установка приложения на главный экран телефона без магазина приложений («Стройка», водитель «Бетона»).
// Android/Chrome — системное окно установки по кнопке; iPhone — подсказка «Поделиться → На экран „Домой“».

import { useEffect, useState } from "react";
import { Button, useToast } from "./ui";

type PromptEvent = Event & { prompt: () => Promise<void>; userChoice: Promise<{ outcome: string }> };
let deferred: PromptEvent | null = null;
const subs = new Set<() => void>();

export function registerPwa(): void {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e as PromptEvent;
    subs.forEach((f) => f());
  });
  window.addEventListener("appinstalled", () => { deferred = null; subs.forEach((f) => f()); });
  if ("serviceWorker" in navigator && window.isSecureContext) {
    window.addEventListener("load", () => { navigator.serviceWorker.register("sw.js").catch(() => { /* без офлайн-режима, но работает */ }); });
  }
}

const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || (navigator as any).standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export function InstallButton({ name = "Приложение" }: { name?: string }) {
  const toast = useToast();
  const [, tick] = useState(0);
  useEffect(() => { const f = () => tick((x) => x + 1); subs.add(f); return () => { subs.delete(f); }; }, []);
  if (standalone()) return null;
  if (deferred) {
    return <Button size="small" onClick={async () => {
      const p = deferred!;
      await p.prompt();
      const r = await p.userChoice;
      deferred = null;
      tick((x) => x + 1);
      if (r.outcome === "accepted") toast.ok(`${name} установлено — значок на главном экране`);
    }}>Установить на телефон</Button>;
  }
  if (isIos()) {
    return <Button size="small" variant="ghost" onClick={() => toast.ok("В Safari нажмите «Поделиться» (квадрат со стрелкой) → «На экран „Домой“»")}>Как установить на iPhone</Button>;
  }
  return null;
}
